export default {
  showRegistrationModalOnQr: false,
  general: {
    showFavourites: true,
    showSoldNeighbourhoods: false,
    showSoldSlides: false,
    appResetTimeoutMinutes: 15,
  },
  filter: {
    enabled: false,
  },
};
